import React from 'react';
import { ThumbsUp, Hand, ThumbsDown } from 'lucide-react';

/**
 * PM Spec V3 13/05/2026 — EmojiStateSelector
 * 3 boutons emoji 👍 👌 👎 → mappés sur actualState (Bon état / Acceptable / Réserves émises).
 * Utilisé pour DRIVER → état du chargement.
 */
const STATES = [
  { value: 'good', label: 'Bon état', Icon: ThumbsUp, bg: 'bg-emerald-50 border-emerald-300', activeBg: 'bg-emerald-600 text-white border-emerald-600' },
  { value: 'acceptable', label: 'Acceptable', Icon: Hand, bg: 'bg-amber-50 border-amber-300', activeBg: 'bg-amber-500 text-white border-amber-500' },
  { value: 'reserve', label: 'Souci', Icon: ThumbsDown, bg: 'bg-red-50 border-red-300', activeBg: 'bg-red-600 text-white border-red-600' },
];

export const EMOJI_TO_TEXT = {
  good: 'Bon état',
  acceptable: 'État acceptable',
  reserve: 'Réserves émises',
};

const EmojiStateSelector = ({ value, onChange, testId = 'emoji-state-selector' }) => {
  return (
    <div className="grid grid-cols-3 gap-3" data-testid={testId}>
      {STATES.map(({ value: v, label, Icon, bg, activeBg }) => {
        const active = value === v;
        return (
          <button
            key={v}
            type="button"
            data-testid={`${testId}-${v}`}
            onClick={() => onChange?.(v)}
            className={`rounded-xl border-2 p-4 flex flex-col items-center justify-center gap-2 transition-all min-h-[100px] ${
              active ? activeBg + ' shadow-md scale-[1.02]' : bg + ' hover:shadow-sm'
            }`}
          >
            <Icon className="w-9 h-9" />
            <span className="text-sm font-semibold">{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default EmojiStateSelector;
